import React from 'react';
import { Hero } from '../components/Hero';
import { Introduction } from '../components/Introduction';
import { AboutJenny } from '../components/AboutJenny';
import { Communities } from '../components/Communities';
import { WhyLasVegas } from '../components/WhyLasVegas';
import { FeaturedListings } from '../components/FeaturedListings';
import { FAQ } from '../components/FAQ';
import { ContactCTA } from '../components/ContactCTA';
export function HomePage() {
  return <main data-id="element-433">
      <Hero data-id="element-434" />
      <Introduction data-id="element-435" />
      <AboutJenny data-id="element-436" />
      <Communities data-id="element-437" />
      <WhyLasVegas data-id="element-438" />
      <FeaturedListings data-id="element-439" />
      <FAQ data-id="element-440" />
      <ContactCTA data-id="element-441" />
    </main>;
}